<shared-toolbar title="Sugerencias">
  <shared-button
    (click)="sendMail()"
    [typeBtn]="'button'"
    [color]="'accent'"
    [icon]="'send'"
    >Enviar Reporte
  </shared-button>
  <shared-search-field (inputValue)="fielInput = $event" [data]="dataSource" />
</shared-toolbar>
<mat-card class="mt-4 p-0 overflow-hidden">
  <mat-card-content class="overflow-y-hidden overflow-x-scroll">
    <table mat-table [dataSource]="dataSource" matSort>
      <!-- Position Column -->
      <ng-container matColumnDef="suggestion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sugerencia</th>
        <td mat-cell *matCellDef="let element">{{ element.suggestion }}</td>
      </ng-container>

      <ng-container matColumnDef="read">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Leído</th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            [checked]="element.read == 1"
            (change)="toggleReadUserSugestions(element)"></mat-checkbox>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
        <td mat-cell *matCellDef="let element">
          {{ element.state }}
        </td>
      </ng-container>

      <ng-container matColumnDef="worker">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Trabajador</th>
        <td mat-cell *matCellDef="let element">{{ element.worker }}</td>
      </ng-container>

      <ng-container matColumnDef="catalog">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Catálogo</th>
        <td mat-cell *matCellDef="let element">
          {{ element.catalog }}
        </td>
      </ng-container>

      <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            color="accent"
            [matMenuTriggerFor]="menu"
            aria-label="Mas opciones">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <a mat-menu-item (click)="modalDelete(element)">
              <mat-icon mat-icon-button color="warn">delete</mat-icon>
              <span>Eliminar</span>
            </a>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">
          No hay resultados para la busqueda: {{ fielInput }}
        </td>
      </tr>
    </table>
    <br />
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>
  </mat-card-content>
</mat-card>
